import * as React from "react";

import { PaywallProvider } from "lib/providers/Paywall";
import { ProHelperProvider } from "lib/providers/ProHelper";

type Props = {
  children: React.ReactNode;
};

export function ReportSubscriptionContextProvider({ children }: Props): JSX.Element {
  return (
    <PaywallProvider>
      <ProHelperProvider>{children}</ProHelperProvider>
    </PaywallProvider>
  );
}
